export default __webpack_public_path__ + "static/media/bg-paper-lite.1ae768e0.jpg";